import * as React from 'react';

import Skeleton from 'react-loading-skeleton';

import {
  Colors,
  Breakpoint,

  useDimensions,

  Text,
} from '@bluecurrent/web-component-lib';

export default function Divider({
  weekday,
  isSolid,
  isLoading,
}) {
  const size = useDimensions();

  return (
    <div
      style={{
        height: '100%',
        minWidth: 4,
        borderLeft: `${isSolid ? 'solid' : 'dashed'} 4px ${Colors.MEDIUM_WHITE}`,
        position: 'relative',
      }}
    >
      {
        isSolid
        && size.width >= Breakpoint.md
        && !isLoading
        && (
          <div
            style={{
              position: 'absolute',
              left: 5,
              top: 30,
              backgroundColor: Colors.MEDIUM_WHITE,
              border: `solid 2px ${Colors.MEDIUM_WHITE}`,
              paddingTop: 5,
              paddingBottom: 5,
              paddingLeft: 10,
              paddingRight: 10,
              borderRadius: 25,
              zIndex: 2,
              minWidth: 75,
            }}
          >
            <Text
              fontSize="0.8em"
              fontWeight={500}
              color="#88888D"
              textAlign="center"
            >
              {weekday ?? '-'}
            </Text>
          </div>
        )
      }
      {
        isSolid
        && size.width >= Breakpoint.md
        && isLoading
        && (
          <Skeleton
            height={25}
            width={100}
            style={{
              borderRadius: 25,
              position: 'absolute',
              left: 5,
              top: 30,
            }}
          />
        )
      }
    </div>
  );
}
